import { render, staticRenderFns } from "./Dialogs_ChangePassword.vue?vue&type=template&id=24ad05d4&scoped=true&"
import script from "./Dialogs_ChangePassword.vue?vue&type=script&lang=js&"
export * from "./Dialogs_ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad05d4",
  null
  
)

export default component.exports